import { DataTable } from "@/components/common/DataTable";
import { StatusBadge } from "@/components/common/StatusBadge";
import { RelevanceScore } from "./RelevanceScore";
import { Users } from "lucide-react";
import { stageBadge, priorityBadge, gbp, isOverdueFollowup } from "@/data/investorOptions";

export const InvestorTable = ({ investors, today, onOpen, onAdd, firstRun }) => {
  const columns = [
    { key: "name", header: "Investor", render: (i) => (
      <button onClick={() => onOpen(i)} data-testid={`open-investor-${i.id}`} className="text-left font-medium text-[#14245F] hover:text-[#C9A227]">{i.name}</button>
    )},
    { key: "investor_type", header: "Type", render: (i) => <span className="text-xs text-[#5A6B8C]">{i.investor_type}</span> },
    { key: "geography", header: "Geography" },
    { key: "contact_person", header: "Contact", render: (i) => i.contact_person || "—" },
    { key: "stage", header: "Stage", render: (i) => <StatusBadge status={stageBadge(i.stage)} label={i.stage} /> },
    { key: "priority", header: "Priority", render: (i) => <StatusBadge status={priorityBadge(i.priority)} label={i.priority} /> },
    { key: "relevance", header: "Relevance", render: (i) => <RelevanceScore value={i.relevance} /> },
    { key: "potential_amount", header: "Potential", render: (i) => <span className="font-medium">{gbp(i.potential_amount)}</span> },
    { key: "probability", header: "Prob.", render: (i) => `${i.probability || 0}%` },
    { key: "next_follow_up_date", header: "Next follow-up", render: (i) => <span className={isOverdueFollowup(i, today) ? "font-semibold text-[#DC2626]" : ""}>{i.next_follow_up_date || "—"}</span> },
    { key: "next_action", header: "Next action", render: (i) => <span className="line-clamp-1 max-w-[180px] text-xs text-[#5A6B8C]">{i.next_action || "—"}</span> },
  ];
  return (
    <DataTable
      testid="investors-table"
      columns={columns}
      rows={investors}
      emptyIcon={Users}
      emptyImage={firstRun ? "/commando-mascot-v2.webp" : undefined}
      emptyTitle="No investors found"
      emptyDescription="Adjust filters or add an investor to start building the pipeline."
      emptyActionLabel="Add investor"
      onEmptyAction={onAdd}
    />
  );
};
